import Button from "./Button";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import { useShare } from "@hooks/trpc/useShare";

const Share = ({
  accessId,
  title,
  width,
}: {
  accessId: string;
  title: string;
  width: number;
}) => {
  const share = useShare();
  const handlePressShare = async () => {
    await share.mutateAsync({
      linkType: "direct-link",
      contentType: "access",
      data: {
        accessId: accessId,
        title: title,
      },
    });
  };
  return (
    <Button.Button
      onPress={handlePressShare}
      sentryEventName="AccessDetail.Share"
      bg="whiteTranslucent20"
      width={width}
    >
      <LIcon colors={{ color: "#FFFFFF80" }} name="share_upload" size={16} />
      <LText variant="Caption/C1/Medium" color="white">
        Share
      </LText>
    </Button.Button>
  );
};

export default Share;
